// Studyo Today Backend
// Package studyo.today.subscriptions.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/subscriptions/v1/resources/product.proto (package studyo.today.subscriptions.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_subscriptions_v1_resources_product_price } from "./product_price_pb.js";

/**
 * Describes the file studyo/today/subscriptions/v1/resources/product.proto.
 */
export const file_studyo_today_subscriptions_v1_resources_product = /*@__PURE__*/
  fileDesc("CjVzdHVkeW8vdG9kYXkvc3Vic2NyaXB0aW9ucy92MS9yZXNvdXJjZXMvcHJvZHVjdC5wcm90bxInc3R1ZHlvLnRvZGF5LnN1YnNjcmlwdGlvbnMudjEucmVzb3VyY2VzIpYBCgdQcm9kdWN0EgoKAmlkGAEgASgJEg0KBXRpdGxlGAIgASgJEhMKC2Rlc2NyaXB0aW9uGAMgASgJEkUKBnByaWNlcxgEIAMoCzI1LnN0dWR5by50b2RheS5zdWJzY3JpcHRpb25zLnYxLnJlc291cmNlcy5Qcm9kdWN0UHJpY2USFAoMZmVhdHVyZV9mbGFnGAUgASgJQi+qAixTdHVkeW8uVG9kYXkuU3Vic2NyaXB0aW9ucy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_studyo_today_subscriptions_v1_resources_product_price]);

/**
 * Describes the message studyo.today.subscriptions.v1.resources.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_resources_product, 0);

